window.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.accordion-item');

    if (accordionItems.length > 0) {
        accordionItems.forEach(item => {
            const accordionHeader = item.querySelector('.accordion__header');

            accordionHeader.onclick = () => {
                accordionItems.forEach(element => {
                    if (element !== accordionHeader.closest('details')) {
                        element.removeAttribute('open');
                    }
                })
            }
        })
    }
});